module.exports = __webpack_public_path__ + "static/media/welcome-bonus.69c78662.png";